import { __assign } from "tslib";
import selectedVideoSet from './bi-handlers/selected-video';
export default __assign({}, selectedVideoSet);
